import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Annoying google drive share link issue if you just copy/paste...`}</p>
    <h1>{`Problem`}</h1>
    <p>{`Recently getting more and more lazy to organize images through blog folders. I know it has a lot of neat image caching/optimization features. Link to Google Drive seems to be a convenient way for me sometimes.`}</p>
    <p>{`Yet, haunted by this issues of converting:`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "https://drive.google.com/file/d/%7BID%7D/view?usp=sharing"
        }}>{`https://drive.google.com/file/d/{ID}/view?usp=sharing`}</a></p>
    </blockquote>
    <p>{`to:`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "https://drive.google.com/uc?export=view&id=%7BID%7D"
        }}>{`https://drive.google.com/uc?export=view&id={ID}`}</a></p>
    </blockquote>
    <h1>{`Solution`}</h1>
    <p>{`Put this in your Ultisnip:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`snippet gimg "google image"
![\${0:\${VISUAL}}](\${1:\`!v
substitute(getreg("*"), "https://drive.google.com/file/d/\\\\(.*\\\\)/view.*", "https://drive.google.com/uc\\\\?export=view\\\\&id=\\\\1", "g")
\`})
endsnippet`}</code></pre></div>
    <p>{`Then it grab the register/clipboard and return the correct google drive link as markdown image. But it's essentially just vim command. Feel free to tailor the line after `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`!v`}</code>{` to your need. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      